import { Font } from '@react-pdf/renderer';

export interface FontSources {
  MaisonNeueBook: string;
  MaisonNeueMedium: string;
  MaisonNeueBookItalic: string;
  MaisonNeueBold: string;
}

/**
 * Shared font registration logic used by both browser and Node.js environments
 */
export function registerFonts(sources: FontSources) {
  // Register fonts
  Font.register({
    family: 'MaisonNeue',
    fonts: [
      { src: sources.MaisonNeueBook, fontWeight: 400 },
      { src: sources.MaisonNeueMedium, fontWeight: 500 },
    ],
  });

  Font.register({
    family: 'MaisonNeue-Book',
    src: sources.MaisonNeueBook,
  });

  Font.register({
    family: 'MaisonNeue-Bold',
    src: sources.MaisonNeueBold,
  });

  Font.register({
    family: 'MaisonNeue-Medium',
    src: sources.MaisonNeueMedium,
  });

  Font.register({
    family: 'MaisonNeue-BookItalic',
    src: sources.MaisonNeueBookItalic,
    fontStyle: 'italic',
  });

  // Register hyphenation callback
  Font.registerHyphenationCallback((word) => [word]);
}
